__turbopack_context__.v({
  "buttons": "OAuthButtons-module__2g0gqa__buttons",
  "divider": "OAuthButtons-module__2g0gqa__divider",
  "dividerLabel": "OAuthButtons-module__2g0gqa__dividerLabel",
  "errorWrap": "OAuthButtons-module__2g0gqa__errorWrap",
  "fbButton": "OAuthButtons-module__2g0gqa__fbButton",
  "fbIcon": "OAuthButtons-module__2g0gqa__fbIcon",
  "googleButton": "OAuthButtons-module__2g0gqa__googleButton",
  "root": "OAuthButtons-module__2g0gqa__root",
});
